import { getSocketClient } from '@frontend/sockets';
import { addSentryBreadcrumb, captureSentryException, captureSentryMessage } from '@frontend/web-utils';
import { Env } from '@frontend/web/utils/env';

export const { disconnectSocket, getSocket, initializeSocket } = getSocketClient({
  addBreadcrumb: addSentryBreadcrumb,
  apiUrl: Env.VITE_API_BASE_URL,
  captureException: captureSentryException,
  captureMessage: captureSentryMessage,
  env: Env.VITE_ENV,
});
